(function() {
  var City, Form, search,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  City = (function() {
    function City() {
      this.init = bind(this.init, this);
      this.filled = bind(this.filled, this);
      this.keypressed = bind(this.keypressed, this);
      this.focused = bind(this.focused, this);
      this.object = document.querySelector('#place');
    }

    City.prototype.bind = function() {
      this.object.addEventListener('keypress', this.keypressed);
      this.object.addEventListener('fill', this.filled);

      $(this.object).autocomplete({
        serviceUrl: this.object.getAttribute('data-autocomplete-service-url'),
        params: { token: this.object.getAttribute('data-autocomplete-token') },
        onSelect: function(suggestion) {
          this.dispatchEvent(new CustomEvent('fill', {
            detail: {
              slug: suggestion.slug,
              lat: suggestion.lat,
              lng: suggestion.lng,
              place_id: suggestion.google_place_id,
              city: suggestion.value
            }
          }))
        }
      });
    };

    City.prototype.keypressed = function(event) {
      if (event.keyCode == 13) {
        event.preventDefault();
      };
    };

    City.prototype.filled = function(event) {
      $(this.object).siblings('.x-city-input-slug').val(event.detail.slug);
      $(this.object).siblings('.x-city-input-lat').val(event.detail.lat);
      $(this.object).siblings('.x-city-input-lng').val(event.detail.lng);
      $(this.object).siblings('.x-city-input-id').val(event.detail.place_id);
      $(this.object).val(event.detail.city);
      document.querySelector('#new_search_form').dispatchEvent(new Event('submit', { cancelable: true }));
    };

    return City;

  })();

  Form = (function() {
    function Form() {
      this.updateActionAttribute = bind(this.updateActionAttribute, this);
      this.submitForm = bind(this.submitForm, this);
      this.disableAutoFill = bind(this.disableAutoFill, this);
      this.init = bind(this.init, this);
      this.render = bind(this.render, this);
      this.sent = bind(this.sent, this);
      this.bind = bind(this.bind, this);
      this.init();
      this.object = document.querySelector('#new_search_form');
    }

    Form.prototype.updateActionAttribute = function() {
      var defaultUrl = 'wyszukaj';

      if ($('#x-city-input-slug').val().length > 0) {
        defaultUrl = $('#x-city-input-slug').val()
      }

      $(event.target).attr('action', '/ksiegowi/' + defaultUrl);
    };

    Form.prototype.submitForm = function() {
      $(event.target).submit();
    };

    Form.prototype.disableAutoFill = function() {
      document.querySelector('#new_search_form').setAttribute('autocomplete', 'new-password');
    }

    Form.prototype.init = function() {
      this.render();
      this.disableAutoFill();
    };

    Form.prototype.render = function() {
      $('#x-accountants-search-container').html('<form class="search-from-homepage x-search-form" id="new_search_form" action="/ksiegowi/wyszukaj" accept-charset="UTF-8" method="get"><input name="utf8" type="hidden" value="✓"><div class="search-field"><label for="main-search">Kontakt z księgowym</label><div class="custom-select"><select class="x-service-type" name="search_form[service][names]" id="search_form_service_names"><option selected="selected" value="online">Online i telefonicznie</option><option value="office">Osobiście</option></select></div></div><div class="search-field"><label for="place">Miejscowość</label> <input placeholder="Wpisz miejsowość" id="place" class="x-search-input x-city-input" autocomplete="new-password" data-autocomplete-token="62d7b0a3-893f-41f3-994c-21a623191ddc" data-autocomplete-service-url="/ksiegowi/api/wewnetrzne/miasta/autouzupelnianie" type="text" value="" name="search_form[city][name]"> <input class="x-city-input-slug" id="x-city-input-slug" type="hidden" value="" name="search_form[city][slug]"> <input class="x-city-input-lat" id="x-city-input-lat" type="hidden" name="search_form[city][lat]"> <input class="x-city-input-lng" id="x-city-input-lng" type="hidden" name="search_form[city][lng]"> <input class="x-city-input-id" id="x-city-input-id" type="hidden" name="search_form[city][place_id]"></div><div class="search-field search-field--btn"><button class="btn btn--green btn--block btn--big x-track-btn" type="submit">Szukaj księgowego</button></div></form>');
    };

    Form.prototype.bind = function() {
      return this.object.addEventListener('submit', this.sent);
    };

    Form.prototype.sent = function(event) {
      event.preventDefault();

      if (($('#search_form_service_names').val() == 'office' || $('#place').val().length > 0) && $('#x-city-input-id').val().length < 1) {
        toastr.error('<strong>Wpisz oraz wybierz miejscowość z listy</strong>, aby móc wyszukać księgowych.');
        document.querySelector('#place').focus();
      } else {
        this.updateActionAttribute();
        this.submitForm();
      }
    };

    return Form;

  })();

  const Search = (function() {
    function Search() {
      this.bind = bind(this.bind, this);
      this.form = new Form();
      this.city = new City();
    }

    Search.prototype.bind = function() {
      this.form.bind();
      this.city.bind();
    };

    return Search;

  })();

  if ($('#x-accountants-search-container').length > 0) {
    search = new Search();
    search.bind();
  }

}).call(this);
